import React, { useState } from 'react'

import styled from 'styled-components'

import { BarComposition } from '../helpers/types'
import { Bar } from './Bar'

const Container = styled.div`
  align-items: flex-end;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  left: 0;
  width: 100%;
`

export const Bars: React.FC<{
  ageOfTransfer: number
  barWidth: number
  barsCompositions: BarComposition[]
  currentAge: number
}> = ({ ageOfTransfer, barWidth, barsCompositions, currentAge }) => {
  const [stopDelay, setStopDelay] = useState(false)
  return (
    <Container>
      {barsCompositions.map((barComposition: BarComposition, index) => {
        return (
          <Bar
            barHeight={barComposition.barHeight}
            barWidth={barWidth}
            hasDelay={!stopDelay}
            index={index}
            investedPercentage={barComposition.investedPercentage}
            isAgeOfTransfer={currentAge + index === ageOfTransfer}
            key={`age-${currentAge + index}`}
            onStopDelay={setStopDelay}
          />
        )
      })}
    </Container>
  )
}
